import React, { useState } from "react";
import { FaTasks, FaClipboardList, FaBuilding, FaUsers } from "react-icons/fa";

const Dashboard = () => {
  // State to control visibility of modals for each section
  const [showTasks, setShowTasks] = useState(false);
  const [showApprovals, setShowApprovals] = useState(false);
  const [showProjects, setShowProjects] = useState(false);

  // Dummy data for each section
  const tasksData = [
    { id: 1, name: "Task 1", description: "Approve building material" },
    { id: 2, name: "Task 2", description: "Review pending inspections" },
    { id: 3, name: "Task 3", description: "Check project progress" },
  ];

  const approvalsData = [
    { id: 1, material: "Cement", status: "Pending" },
    { id: 2, material: "Steel", status: "Approved" },
  ];

  const projectsData = [
    { id: 1, name: "Project A", status: "In Progress" },
    { id: 2, name: "Project B", status: "Completed" },
  ];

  return (
    <div className="relative flex-1 p-10 overflow-y-auto ml-7 mr-2 min-h-screen">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* Dashboard Cards */}
        <div className="bg-white shadow-lg rounded-lg p-6 hover:scale-105 transition-all duration-300 cursor-pointer">
          <div className="flex items-center mb-4">
            <FaTasks className="text-blue-600 text-3xl mr-4" />
            <h3 className="text-xl font-semibold">Pending Tasks</h3>
          </div>
          <p className="text-gray-600">5 tasks awaiting approval</p>
          <button
            onClick={() => setShowTasks(true)}
            className="mt-4 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-500 transition-all duration-300"
          >
            View Tasks
          </button>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 hover:scale-105 transition-all duration-300 cursor-pointer">
          <div className="flex items-center mb-4">
            <FaClipboardList className="text-green-600 text-3xl mr-4" />
            <h3 className="text-xl font-semibold">Material Approvals</h3>
          </div>
          <p className="text-gray-600">2 materials awaiting approval</p>
          <button
            onClick={() => setShowApprovals(true)}
            className="mt-4 bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-500 transition-all duration-300"
          >
            View Approvals
          </button>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 hover:scale-105 transition-all duration-300 cursor-pointer">
          <div className="flex items-center mb-4">
            <FaBuilding className="text-yellow-600 text-3xl mr-4" />
            <h3 className="text-xl font-semibold">Project Updates</h3>
          </div>
          <p className="text-gray-600">3 projects in progress</p>
          <button
            onClick={() => setShowProjects(true)}
            className="mt-4 bg-yellow-600 text-white py-2 px-4 rounded-md hover:bg-yellow-500 transition-all duration-300"
          >
            View Projects
          </button>
        </div>
      </div>

      {/* Task Modal */}
      {showTasks && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/2">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Pending Tasks</h2>
            <ul>
              {tasksData.map((task) => (
                <li key={task.id} className="mb-4">
                  <h3 className="font-semibold">{task.name}</h3>
                  <p className="text-gray-600">{task.description}</p>
                </li>
              ))}
            </ul>
            <button
              onClick={() => setShowTasks(false)}
              className="mt-4 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-500 transition-all duration-300"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Approvals Modal */}
      {showApprovals && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/2">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Material Approvals</h2>
            <ul>
              {approvalsData.map((approval) => (
                <li key={approval.id} className="mb-4">
                  <h3 className="font-semibold">{approval.material}</h3>
                  <p className="text-gray-600">Status: {approval.status}</p>
                </li>
              ))}
            </ul>
            <button
              onClick={() => setShowApprovals(false)}
              className="mt-4 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-500 transition-all duration-300"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Projects Modal */}
      {showProjects && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/2">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Project Updates</h2>
            <ul>
              {projectsData.map((project) => (
                <li key={project.id} className="mb-4">
                  <h3 className="font-semibold">{project.name}</h3>
                  <p className="text-gray-600">Status: {project.status}</p>
                </li>
              ))}
            </ul>
            <button
              onClick={() => setShowProjects(false)}
              className="mt-4 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-500 transition-all duration-300"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Recent Notifications at the Bottom */}
      <div className="bg-white shadow-lg rounded-lg p-6 mt-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Recent Notifications</h2>
        <div className="space-y-4">
          <div className="flex items-center text-gray-700">
            <FaUsers className="text-blue-500 mr-3" />
            <p>New user registered: John Doe</p>
          </div>
          <div className="flex items-center text-gray-700">
            <FaTasks className="text-blue-500 mr-3" />
            <p>Task #12 approved by admin</p>
          </div>
          <div className="flex items-center text-gray-700">
            <FaClipboardList className="text-green-500 mr-3" />
            <p>Material A has been approved for Project B</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
